var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6 0C22.92 0 23.988 1.08 23.988 2.4L24 24L19.2 19.2H2.4C1.08 19.2 0 18.12 0 16.8V2.4C0 1.08 1.08 0 2.4 0H21.6ZM5.99993 14.3999H17.9999C18.6599 14.3999 19.1999 13.8599 19.1999 13.1999C19.1999 12.5399 18.6599 11.9999 17.9999 11.9999H5.99993C5.33993 11.9999 4.79993 12.5399 4.79993 13.1999C4.79993 13.8599 5.33993 14.3999 5.99993 14.3999ZM17.9999 10.8H5.99993C5.33993 10.8 4.79993 10.26 4.79993 9.6C4.79993 8.94 5.33993 8.4 5.99993 8.4H17.9999C18.6599 8.4 19.1999 8.94 19.1999 9.6C19.1999 10.26 18.6599 10.8 17.9999 10.8ZM5.99993 7.19995H17.9999C18.6599 7.19995 19.1999 6.65995 19.1999 5.99995C19.1999 5.33995 18.6599 4.79995 17.9999 4.79995H5.99993C5.33993 4.79995 4.79993 5.33995 4.79993 5.99995C4.79993 6.65995 5.33993 7.19995 5.99993 7.19995Z",
    fill: "#555893"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsIcon);
export default __webpack_public_path__ + "static/media/comments-icon.34deba35.svg";
export { ForwardRef as ReactComponent };